import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import type { DialogAlignment, SlotOrientation, DialogWidth } from './types';

export const getActionsCss = ({
  alignment = 'start',
  hasSlot = false,
  slotOrientation,
  width,
}: {
  alignment?: DialogAlignment;
  hasSlot?: boolean;
  slotOrientation?: SlotOrientation;
  width?: DialogWidth;
} = {}) => {
  // Apply center alignment if no slot OR if slot is vertical (on top)
  // Center is not allowed for horizontal slots (TypeScript enforces this)
  const shouldCenter =
    alignment === 'center' && (!hasSlot || slotOrientation === 'verticalTop');

  const isSmall = width === 'small';
  const spacing = isSmall ? 'var(--cds-spacing-200)' : 'var(--cds-spacing-300)';

  return css`
    grid-area: actions;
    background-color: inherit;
    padding: var(--cds-spacing-200) ${spacing} ${spacing} ${spacing};

    ${shouldCenter &&
    'display: flex; justify-content: center; flex-wrap: wrap;'}

    ${breakpoints.down('xs')} {
      padding: var(--cds-spacing-150) var(--cds-spacing-200)
        var(--cds-spacing-200) var(--cds-spacing-200);
    }
  `;
};

export const getStickyActionsCss = () => {
  return css`
    position: sticky;
    bottom: 0;
    background-color: var(--cds-color-neutral-background-primary);
  `;
};
